// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";

function EvidenceImageCard({ image, title }) {
  const imageTemplate = (
    <MKBox position="relative" borderRadius="lg" textAlign="center">
      <MKBox
        component="img"
        src={image}
        alt={title}
        borderRadius="md"
        shadow="md"
        width="100%"
        position="relative"
        zIndex={1}
        sx={{
          maxWidth: "100%",
          width: "auto",
          height: "auto",
          "@media (max-width:600px)": {
            maxWidth: "100%",
            width: "75%",
          },
        }}
      />
      <MKBox
        borderRadius="lg"
        shadow="md"
        width="100%"
        height="100%"
        position="absolute"
        left={0}
        top={0}
        sx={{
          backgroundImage: `url(${image})`,
          transform: "scale(0.94)",
          filter: "blur(12px)",
          backgroundSize: "cover",
          "@media (max-width:600px)": {
            transform: "scale(0.74)",
          },
        }}
      />
    </MKBox>
  );

  return (
    <Card
      sx={{
        background: "transparent",
        boxShadow: "none",
        overflow: "visible",
      }}
    >
      {imageTemplate}
    </Card>
  );
}

// Typechecking props for the TransparentBlogCard
EvidenceImageCard.propTypes = {
  image: PropTypes.string.isRequired,
};

export default EvidenceImageCard;
